module.exports = __webpack_public_path__ + "static/img/co3.6554bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co3.jpg
// module id = c6T6
// module chunks = 11